module.exports = __webpack_public_path__ + "img/seguro.39ec2281.png";